import React from 'react'
import { VEC_ICON_NAME } from '../../../../../../components/icons/constants'
import ConfirmationPopup from '../../../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { BUTTON_TYPE } from '../../../../../../components/button/constants'

const ConfirmationModal = ({ isOpen, onCancelCb = () => { }, onSubmitCb = () => { } }) => {
    return (
        <ConfirmationPopup
            title='Are you sure?'
            bodyText='Do you want to Request eDelivery?'
            iconName={VEC_ICON_NAME.WARNING_ICON}
            isOpen={isOpen}
            confirmationButtonProps={{
                onConfirmationCb: onSubmitCb,
                confirmationButtonText: "Proceed",
                confirmationButtonStyles: {},
                confirmationButtonType: BUTTON_TYPE.PRIMARY,
            }}
            cancelButtonProps={{
                onCancelCb: onCancelCb,
                cancelButtonText: "Cancel",
                cancelButtonStyles: {},
                cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
            }}
        />
    )
}

export default ConfirmationModal
